// frontend/src/utils/postUrls.ts

/**
 * Generate URL for a legacy post (user profile post)
 * Pattern: /u/[username]/[slug]
 */
export function getLegacyPostUrl(username: string, slug: string): string {
  return `/u/${username}/${slug}`;
}

/**
 * Generate URL for a community post
 * Pattern: /community/[communitySlug]/[postSlug]
 */
export function getCommunityPostUrl(communitySlug: string, postSlug: string): string {
  return `/community/${communitySlug}/${postSlug}`;
}

/**
 * Generate URL for a forum post
 * Pattern: /community/[communitySlug]/forum/[postSlug]
 */
export function getForumPostUrl(communitySlug: string, postSlug: string): string {
  return `/community/${communitySlug}/forum/${postSlug}`;
}

/**
 * Generate URL for a community
 * Pattern: /community/[communitySlug]
 */
export function getCommunityUrl(communitySlug: string): string {
  return `/community/${communitySlug}`;
}

/**
 * Generate URL for a user profile
 * Pattern: /u/[username]
 */
export function getProfileUrl(username: string): string {
  return `/u/${username}`;
}
